import angular from "angular";

angular
    .module('app')
    .component('videoModalPlayer', {
        template: require('./video-modal-player.html'),
        controller: ['$sce', '$timeout', '$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($sce, $timeout, $http) {

    let $ctrl = this;

    $ctrl.theme = '/videogular/videogular.min.css';

    $ctrl.quality = '360';

    $ctrl.getVideoLoading = false;

    $ctrl.$onInit = function () {

        $ctrl.video = $ctrl.resolve.video;

        $ctrl.getVideo();
    };

    $ctrl.getVideo = function () {
        $ctrl.getVideoLoading = true;
        $http.get(`/admin/videos/get-video/${$ctrl.video.id}`)
            .then(function (resp) {
                $ctrl.video = resp.data;
                $ctrl.videos = [
                    {
                        name: $ctrl.video.name,
                        infos: [
                            {
                                'quality': '360',
                                'status': $ctrl.video.sm_status ? $ctrl.video.sm_status : null,
                                'start_date': $ctrl.video.sm_start_date ? $ctrl.video.sm_start_date : null,
                                'finish_date': $ctrl.video.sm_finish_date ? $ctrl.video.sm_finish_date : null,
                            },
                            {
                                'quality': '480',
                                'status': $ctrl.video.md_status ? $ctrl.video.md_status : null,
                                'start_date': $ctrl.video.md_start_date ? $ctrl.video.md_start_date : null,
                                'finish_date': $ctrl.video.md_finish_date ? $ctrl.video.md_finish_date : null,
                            },
                            {
                                'quality': '720',
                                'status': $ctrl.video.lg_status ? $ctrl.video.lg_status : null,
                                'start_date': $ctrl.video.lg_start_date ? $ctrl.video.lg_start_date : null,
                                'finish_date': $ctrl.video.lg_finish_date ? $ctrl.video.lg_finish_date : null,
                            }
                        ],
                    }
                ];

                $ctrl.getVideoLoading = false;

            }, function () {
                alert('err');
                $ctrl.getVideoLoading = false;
            })
    };


    $timeout(function () {
        $ctrl.qualitySources = [
            {
                name: '720p',
                sources: [
                    {
                        src: $sce.trustAsResourceUrl($ctrl.video.lg_path),
                        type: "video/mp4"
                    }
                ]
            },
            {
                name: '480p',
                sources: [
                    {
                        src: $sce.trustAsResourceUrl($ctrl.video.md_path),
                        type: "video/mp4"
                    }
                ]
            },
            {
                name: '360p',
                sources: [
                    {
                        src: $sce.trustAsResourceUrl($ctrl.video.sm_path),
                        type: "video/mp4"
                    }
                ]
            }
        ];
        $ctrl.currentQualitySource = $ctrl.qualitySources[$ctrl.qualitySources.length - 1];
    }, 2);
}
